'use strict';
import { useCallback, useEffect, useRef, useState } from 'react';

export const useAccessSearch = ({ accessTabsConfig, activeTabIndex }) => {
	const [searchText, setSearchText] = useState('');
	const debounceTimeoutRef = useRef(null);

	const handleSearchChange = useCallback(() => {
		// No-op: SearchBox manages its own input state
	}, []);

	const handleDebouncedSearch = useCallback((text) => {
		if (debounceTimeoutRef.current) {
			clearTimeout(debounceTimeoutRef.current);
		}

		const currentConfig = accessTabsConfig[activeTabIndex];
		const debounceMs = currentConfig?.search?.debounceMs || 800;
		debounceTimeoutRef.current = setTimeout(() => {
			setSearchText(text);
		}, debounceMs);
	}, [accessTabsConfig, activeTabIndex]);

	const handleSearchKeyUp = useCallback((valueOrEvent) => {
		const value = typeof valueOrEvent === 'string'
			? valueOrEvent
			: valueOrEvent?.target?.value || '';

		if (value === '') {
			if (debounceTimeoutRef.current) {
				clearTimeout(debounceTimeoutRef.current);
			}
			setSearchText('');
			return;
		}

		handleDebouncedSearch(value);
	}, [handleDebouncedSearch]);

	const clearDebounce = useCallback(() => {
		if (debounceTimeoutRef.current) {
			clearTimeout(debounceTimeoutRef.current);
		}
	}, []);

	useEffect(() => {
		return () => {
			if (debounceTimeoutRef.current) {
				clearTimeout(debounceTimeoutRef.current);
			}
		};
	}, []);

	return {
		searchText,
		setSearchText,
		handleSearchChange,
		handleSearchKeyUp,
		clearDebounce,
	};
};

export default useAccessSearch;
